import { Reveal } from "@/lib/motion";
import { motion } from "framer-motion";

const stats = [
  { value: "+100", label: "zadowolonych kobiet" },
  { value: "8 lat", label: "doświadczenia w treningu" },
  { value: "1:1", label: "w pełni personalne podejście" },
  { value: "100%", label: "planu skrojonego pod Ciebie" },
];

export const About = () => (
  <section id="ometmnie" className="relative py-16 md:py-24">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      {/* Text */}
      <div className="max-w-4xl">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B6B]">O mnie</span>
          <h2 className="font-display font-light text-4xl md:text-6xl mt-6 leading-[0.95]">
            Prowadzę kobiety do formy, <span className="italic text-[#FF6B6B]">w której czują się sobą</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 space-y-5 text-muted text-base md:text-lg leading-relaxed max-w-2xl">
            <p>
              Cześć! Jestem trenerką personalną w Zdrofit Warszawa Stegny i od lat specjalizuję się w
              pracy z kobietami 30+, które chcą schudnąć zdrowo — bez głodówek, katorżniczych diet i
              wiecznego poczucia winy.
            </p>
            <p>
              Przez ten czas pomogłam <span className="text-[#F5F2F0] font-medium">ponad 100 kobietom</span>{" "}
              wrócić do formy, zmieścić się w ulubioną sukienkę i znów poczuć lekkość oraz pewność
              siebie. Wiem, że każda z Was jest inna — dlatego każdy plan układam indywidualnie, pod
              Twoje ciało, tempo i życie.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-px border border-[#2A2626]">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="p-6 md:p-7 border-r border-b border-[#2A2626] h-full">
                <motion.p className="font-display text-4xl md:text-5xl text-[#FF6B6B] leading-none">
                  {s.value}
                </motion.p>
                <p className="text-xs uppercase tracking-[0.12em] text-muted mt-3 leading-relaxed">
                  {s.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
